module.exports = __webpack_public_path__ + "img/zfb.c222ed70.png";